<template>
  <div class="application-field" :class="fieldClassObject">
    <div class="field-content">
      <!-- label -->
      <div class="field-label" :class="fieldLabelClassObject">{{field.label}}<span v-if="field.require" class="fg-red">*</span></div>
      <!-- ctrl -->
      <div class="field-ctrl" :class="fieldCtrlClassObject" :style="fieldCtrlStyleObject">
        <template v-if="!fieldDisabled">
          <!-- 文本/数字/电话 -->
          <el-input
            class="input-field"
            v-if="field.type === 'InputBox'"
            v-model.trim="fieldModel"
            :class="{ 'upper-case': field.tran2up }"
            :id="field.name + '-' + fieldIndex"
            :type="field.inputType || 'text'"
            :name="popupName ? popupName + '-' + field.name : field.name"
            :disabled="fieldDisabled || field.onlyRead"
            :readonly="fieldDisabled || field.onlyRead"
            :placeholder="field.placeholder || ''"
            :maxlength="field.maxLength || 200"
            @blur="fieldDataChanged = true;"
          ></el-input>
          <!-- 单选 -->
          <el-radio-group
            class="radio-field"
            v-if="isRadioField"
            v-model="fieldModel"
            :name="popupName ? popupName + '-' + field.name : field.name"
            :id="field.name + '-' + fieldIndex"
            @blur="fieldDataChanged = true;"
          >
          <!-- TODO  -->
            <el-radio
              v-for="(valueItem, index) in field.values"
              :key="index"
              :label="valueItem.value"
              :disabled="fieldDisabled"
            >{{valueItem.label}}</el-radio>
          </el-radio-group>

          <!-- 单选/多选/国家 -->
          <el-select
            class="select-field"
            v-if="isSelectField"
            v-model="fieldModel"
            :filterable="this.field.type === 'CountryBox' || this.field.searchable"
            :clearable="true"
            :no-match-text="this.field.type === 'CountryBox' ? '没有找到任何国家' : '无匹配数据'"
            :multiple="field.multiple"
            :multiple-limit="field.multipleLimit"
            :name="popupName ? popupName + '-' + field.name : field.name"
            :id="field.name + '-' + fieldIndex"
            :placeholder="field.placeholder || ''"
            @visible-change="selectDropDownChange"
          >
            <el-option
              v-for="item in selectFieldValues"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <form-select-standard-country
            v-if="field.type === 'StandardCountryBox'"
            v-model="fieldModel"
            :field-config="field"
            :name="popupName ? popupName + '-' + field.name : field.name"
            :id="field.name + '-' + fieldIndex"
            :placeholder="field.placeholder ? field.placeholder : ''"
          ></form-select-standard-country>


          <div class="date-picker-box">
            <el-date-picker
              class="date-field"
              :class="{ 'space-for-to-now': field.toNow }"
              type="date"
              v-if="field.type === 'DateBox' && !field.yearMonth"
              v-model="fieldModel"
              :disabled="fieldDisabled || datePickerSelectToNow"
              :readonly="fieldDisabled"
              :popper-class="'application-date-picker'"
              :editable="true"
              :clearable="true"
              :name="popupName ? popupName + '-' + field.name : field.name"
              :id="field.name + '-' + fieldIndex"
              :placeholder="field.placeholder ? field.placeholder : 'yyyy-mm-dd'"
              @blur="fieldDataChanged = true;"
              @change="(newDate) => { datePickerValue = newDate }"
            ></el-date-picker>

            <el-date-picker
              class="date-field"
              :class="{ 'space-for-to-now': field.toNow }"
              type="month"
              v-if="field.type === 'DateBox' && field.yearMonth"
              v-model="fieldModel"
              :disabled="fieldDisabled || datePickerSelectToNow"
              :readonly="fieldDisabled"
              :popper-class="'application-date-picker'"
              :editable="true"
              :clearable="true"
              :name="popupName ? popupName + '-' + field.name : field.name"
              :id="field.name + '-' + fieldIndex"
              :placeholder="field.placeholder ? field.placeholder : 'yyyy-mm'"
              @blur="fieldDataChanged = true;"
              @change="(newDate) => { datePickerValue = newDate }"
            ></el-date-picker>

            <el-checkbox
              class="to-now-check-box"
              v-if="field.toNow"
              v-model="datePickerSelectToNow"
              @change="toNowChanged"
            >至今</el-checkbox>
          </div>

          <!-- 省市区选择 -->
          <application-pcd-picker
            class="pcd-field"
            v-if="field.type === 'CityPicker'"
            v-model="fieldModel"
            :id="field.name + '-' + fieldIndex"
            :onlyCity="!!field.onlyCity"
            :field="field"
            :field-index="fieldIndex"
            :field-disabled="fieldDisabled"
            :application-data="applicationData"
            :pcd-data="pcdData"
          ></application-pcd-picker>

          <application-thailand-pcd-picker
            class="pcd-field"
            v-if="field.type === 'ThailandCityPicker'"
            v-model="fieldModel"
            :id="field.name + '-' + fieldIndex"
            :field="field"
            :field-index="fieldIndex"
            :field-disabled="fieldDisabled"
            :application-data="applicationData"
          ></application-thailand-pcd-picker>
        </template>
        <template v-else-if="field.type === 'ThailandCityPicker'">
          {{ getThailandCityPickerDisplayData(fieldModel) }}
        </template>
        <template v-else-if="field.type === 'StandardCountryBox'">
          <form-select-standard-country
            v-model="fieldModel"
            :field-config="field"
            :name="popupName ? popupName + '-' + field.name : field.name"
            :id="field.name + '-' + fieldIndex"
            :placeholder="field.placeholder ? field.placeholder : ''"
            :readonly="true"
          ></form-select-standard-country>
        </template>
        <template v-else>{{fieldDisplayData}}</template>
      </div>
    </div>

    <!-- 错误消息 -->
    <div class="field-ctrl-error-msg" :style="fieldCtrlStyleObject" v-if="!fieldValid">
      <!-- 必填 -->
      <template v-if="field.require && fieldDataEmpty">
        <span v-if="field.type === 'InputBox'">请输入{{field.label}}</span>
        <span
          v-if="isRadioField || isSelectField || field.type === 'DateBox' || field.type === 'CityPicker'"
        >请选择{{field.label}}</span>
      </template>

      <!-- 正则验证错误 -->
      <template v-if="fieldModel && fieldPatternErrorMsg">
        <span>{{fieldPatternErrorMsg}}</span>
      </template>

      <!-- 日期格式错误 -->
      <!-- <template v-if="fieldModel && !datePickerInputValueValid">
        <span>格式错误，请重新填写</span>
      </template>-->
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';

import { regInvalids } from '../../../regs/application-regs';
import countryCodes from '../../../constants/country-code-constants';
import countryEnCodes from '../../../constants/country-en-code-constants';
import provinceArr from '../../../constants/provinces-constants';
import relations from '../../../constants/relations-constants';
import relationsByAustraliaElec from '../../../constants/relations-by-australia-elec';
import crimeTypeByAustraliaElec from '../../../constants/crime-type-by-australia-elec';
import applicationNation from '../../../constants/application-nation-constants';
import AmericaState from '../consts/america-state';
import schengenCountry from '../consts/schengen-country';

import applicationFromService from '../../../services/application-form-service';
import applicationHiddenFieldService from '../../../services/application-hidden-field-service';

import applicationPcdPicker from './application-pcd-picker';
import applicationThailandPcdPicker from './application-thailand-pcd-picker';
import residencyIdForThailand from '../../../datas/ResidencyIdForThailand.json';
import thailandRegion from '../../../datas/thailand-city.json';
import FormSelectStandardCountry from './form/form-select-standard-country.vue';

// 转为相同的格式
const countries = Object.keys(countryCodes).map(code => ({ value: countryCodes[code], label: countryCodes[code] }));
const countriesEn = Object.keys(countryEnCodes).map(code => ({ value: countryEnCodes[code], label: countryEnCodes[code] }));
const provinces = provinceArr.map(province => ({ label: province, value: province }));

export default {
  name: 'application-field',
  components: {
    applicationPcdPicker,
    applicationThailandPcdPicker,
    FormSelectStandardCountry,
  },
  props: {
    field: { // 字段对象
      type: Object,
      required: true,
      default: () => ({}),
    },
    fieldIndex: { // 字段序号，主要是用于给id
      type: Number,
      required: true,
      default: 0,
    },
    fieldDisabled: { // 字段是否禁用
      type: Boolean,
      required: true,
      default: false,
    },
    applicationData: { // 申请表填写的所有数据对象
      type: Object,
      required: true,
      default: () => ({}),
    },
    pcdData: { // 省市区数据，主要是为了保证一份，但是尽量先不使用vuex
      type: Object,
      required: true,
      default: () => ({}),
    },
    ctrlWidth: { // ctrl的宽度，这个主要是针对popup做适配
      type: Number,
      default: 500,
    },
    groupSubmitted: { // 组是否提交
      type: Boolean,
      required: true,
      default: false,
    },
    popupIndex: { // 这个属性是在popup的时候指定当前字段是popup数组中的第几项
      type: Number,
      default: 0,
    },
    popupName: { // 这个属性是在popup中使用的时候，告诉当前组件，popup在全局applicationData中的属性名字
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countries, // 国家列表
      countriesEn, // 英文国家列表
      relations, // 关系列表
      provinces, // 省列表
      regExp: null, // 当前字段的pattern对象，不要在计算属性中每次new
      autoFillWatcherFunction: null, // 取消观察的watcher函数
      fieldDataChanged: false, // 字段是否被touch过，blur一下就算
      datePickerValue: '', // 日期字符串独享的当前值记录变量
      datePickerInputValueValid: true, // 专门给日期选择框使用的输入内容是否合法字段
      datePickerSelectToNow: false, // 专门给日期选择使用的至今选择
    };
  },
  computed: {

    // 字段空
    fieldDataEmpty() {

      // 针对多选下拉
      if (this.fieldModel instanceof Array) {
        return this.fieldModel.length === 0;
      }
      return !this.fieldModel || (this.fieldModel && this.fieldModel.trim() === '');
    },

    // 单选字段(仅PC端限定为单选且选项有且只有三个以下的时候显示这种radio)
    isRadioField() {
      return this.field.type === 'SelectBox'
             && !this.field.multiple
             && this.field.values
             && this.field.values.length > 0
             && this.field.values.length < 3;
    },

    // 单选/多选/国家
    isSelectField() {
      return (this.field.type === 'SelectBox' || this.field.type === 'CountryBox')
        && (!this.field.values || !(this.field.values && this.field.values.length > 0 && this.field.values.length < 3));
    },

    // 字段正则验证失败
    isFieldPatternValid() {
      if (this.field.pattern) {
        return this.regExp.test(this.fieldModel);
      }
      return true;
    },

    fieldPatternErrorMsg() {
      if (!this.field.pattern) return '';
      if (typeof this.field.pattern === 'function') {
        const errMsg = this.field.pattern(this.fieldModel, {
          application_content: this.applicationData,
          popup_item: this.applicationData[this.popupName] ? this.applicationData[this.popupName][this.popupIndex] : undefined,
          dataModel: this.applicationData,
        });
        return errMsg;
      } else if (!new RegExp(this.field.pattern).test(this.fieldModel)) {
        return this.field.patternErrorMsg || '格式错误，请重新填写';
      }
      return '';
    },

    // 字段label的class对象
    fieldLabelClassObject() {
      return {
        'level-2': this.field.level2 || this.popupName, // 第二级 或者 在弹出窗内
        'level-4': this.field.level4,
        invalid: !this.fieldValid,
      };
    },

    // 字段Ctrl的style对象
    fieldCtrlStyleObject() {
      let width = `${this.ctrlWidth}px`;
      if (this.field.level2) {
        width = `${this.ctrlWidth - 20}px`;
      } else if (this.field.level4) {
        width = `${this.ctrlWidth - 40}px`;
      }
      return {
        width, // 20 是level-2的padding宽度
      };
    },

    // 字段Ctrl的class对象
    fieldCtrlClassObject() {
      return {
        invalid: !this.fieldValid,
      };
    },

    // 字段class对象
    fieldClassObject() {
      return {
        'radio-field': this.isRadioField, // 单选
        hidden: this.field.hidden, // 隐藏字段
        'level-2': this.field.level2, // 二级字段
        'level-4': this.field.level4,
      };
    },

    // 字段显示的内容
    fieldDisplayData() {
      if (this.isRadioField) {
        const data = _.find(this.field.values, value => value.value === this.fieldModel);
        return data ? data.label : '';
      }
      if (this.isSelectField && this.field.type !== 'CountryBox') {
        // 增加多选框逻辑
        let data;
        if (this.field.multiple && this.fieldModel instanceof Array) {
          data = [];
          this.selectFieldValues.forEach((value) => {
            if (this.fieldModel.indexOf(value.value) > -1) {
              data.push(value.label);
            }
          });
          if (data && data.length > 0) {
            return data.join(',');
          }
          return '';
        }
        data = _.find(this.selectFieldValues, value => value.value === this.fieldModel);

        return data ? data.label : '';
      }
      return this.fieldModel;
    },

    // 字段是否合法
    fieldValid() {
      if (this.groupSubmitted || this.fieldDataChanged) {
        if (this.popupName) {
          // 这里虽然所有的都加上了下面日期的合法验证，但是其实只有日期的才会起作用，因为其他的都是true
          return applicationFromService.fieldValid(
            this.applicationData,
            this.field,
            this.applicationData[this.popupName] ? this.applicationData[this.popupName][this.popupIndex] : {},
          );
        }
        return applicationFromService.fieldValid(this.applicationData, this.field);
      }
      return true;
    },

    // 字段模型
    fieldModel: {
      get() {
        const fieldValue = this.applicationData[this.field.name];

        // popup取值
        if (this.popupName) {

          // popup的数据在applicationData中是一个数组（如果有）
          const popupFieldValue = this.applicationData[this.popupName];

          // 如果有，需要满足下标要求
          if (popupFieldValue && popupFieldValue.length > 0 && popupFieldValue.length > this.popupIndex) {
            const innerFieldValue = popupFieldValue[this.popupIndex][this.field.name];

            // 这里最好还是有这个数组的保护
            if (this.field.type === 'SelectBox' && this.field.multiple && !(innerFieldValue instanceof Array)) {
              return [];
            }

            return popupFieldValue[this.popupIndex][this.field.name];
          }

          // 这里最好还是有这个数组的保护
          if (this.field.type === 'SelectBox' && this.field.multiple && !(fieldValue instanceof Array)) {
            return [];
          }

          // 如果都没有就暂时返回空字符串，考虑要不要处理字符串和数字？
          return '';
        }

        // 多选保护
        if (this.field.type === 'SelectBox' && this.field.multiple && !(fieldValue instanceof Array)) {
          return [];
        }

        return fieldValue;
      },
      set(newValue) {
        if (newValue !== undefined) {

          let result = newValue;

          // 替换掉不合法的内容
          if (typeof result === 'string') {
            result = result.replace(regInvalids, '');
          }

          if (this.field.tran2up && typeof result === 'string') {
            result = result.toUpperCase();
          }

          // 日期的直接格式化为日期字符串
          if (typeof result === 'object' && result instanceof Date) {
            result = moment(result).format(this.field.yearMonth ? 'YYYY-MM' : 'YYYY-MM-DD');
          }

          this.changeFieldValue(this.field.name, result);
        } else {
          this.changeFieldValue(this.field.name, '');
        }
      },
    },

    countryList() {
      let list = this.field.language === 'english' ? this.countriesEn : this.countries;
      if (this.field.notRegion) {
        const regionList = ['中国香港', '中国澳门', '中国台湾', 'Hong Kong (China)', 'Macau (China)', 'Taiwan (China)'];
        list = list.filter(item => regionList.indexOf(item.value) === -1);
      }
      if (this.field.hideCountryList) {
        list = list.filter(item => this.field.hideCountryList.indexOf(item.value) === -1);
      }
      return list;
    },

    // 当前字段的下拉选项列表
    selectFieldValues() {

      // 这里和h5端不同，这里可以直接使用下拉来做国家选择
      if (this.field.type === 'CountryBox') {
        return this.countryList;
      }

      switch (parseInt(this.field.valuesType, 10)) {
        case 1:
          return this.provinces;
        case 2:
          return this.relations;
        case 9:
          return residencyIdForThailand.map(item => ({
            label: item.Name,
            value: item.Name,
          }));
        case 10:
          return relationsByAustraliaElec;
        case 11:
          return crimeTypeByAustraliaElec;
        case 12:
          return applicationNation;
        case 13:
          return Object.keys(AmericaState).map(key => ({
            label: AmericaState[key],
            value: key,
          }));
        case 14:
          return schengenCountry;
        default:
          return this.field.values || [];
      }
    },
  },
  methods: {

    // 日期输入框离开的时候要验证错误（暂时停用）
    datePickerBlur(fieldId) {
      this.fieldDataChanged = true;
      const isValid = /^\d{4}-\d{2}-\d{2}/.test(document.querySelector(`#${fieldId} input`).value);
      this.datePickerInputValueValid = isValid;
    },

    // 日期输入框输入验证（暂时停用）
    datePickerChange(dateString) {
      const isValid = /^\d{4}-\d{2}-\d{2}/.test(dateString);
      this.datePickerInputValueValid = isValid;
    },

    getThailandCityPickerDisplayData(fieldModel) {
      let result = '';
      if (fieldModel && fieldModel.length > 0) {
        const [cityID, districtID, subDistrictID] = fieldModel;
        const cityObj = thailandRegion.find(city => city.id === cityID);
        const districtObj = cityObj.district.find(district => district.id === districtID);
        const subDistrictObj = districtObj.sub_district.find(subDistrict => subDistrict.id === subDistrictID);

        result = `${cityObj.name} ${districtObj.name}`;
        if (subDistrictObj) {
          result = `${result} ${subDistrictObj.name}`;
        }

        result = result.trim();
      }

      return result;
    },

    // 选择内容弹出首期，模拟blur
    selectDropDownChange(show) {
      if (!show && this.field.require && !this.fieldModel) {
        this.fieldDataChanged = true;
      }
    },

    // 至今的选择改变了
    toNowChanged(event) {
      const checked = event.target.checked;
      if (checked) {
        this.fieldModel = '至今';
      } else {
        this.fieldModel = this.datePickerValue;
      }
    },

    // 改为大写
    toUppercase(value) {
      const trimedValue = value.trim();
      if (this.field.tran2up) {
        this.changeFieldValue(this.field.name, trimedValue ? trimedValue.toUpperCase().trim() : '');
      }
    },

    // 改变字段内容
    changeFieldValue(name, value) {
      this.$emit('fieldValueChanged', {
        name,
        value,
      });
    },

    // 设置正则表达式
    setRegExp() {
      if (this.field.pattern) {
        this.regExp = new RegExp(this.field.pattern);
      }
    },

    // 获取监听来源的值
    getFromValues(fromKeys, applicationData) {
      const fromValues = [];
      fromKeys.forEach((key) => {
        const trimedKey = key.trim();
        let fromKeyValue = '';

        // 如果是在popup里面
        if (this.popupName) {

          // 层层保护
          if (applicationData[this.popupName] && applicationData[this.popupName].length > 0) {
            if (applicationData[this.popupName][this.popupIndex]) {
              fromKeyValue = applicationData[this.popupName][this.popupIndex][trimedKey];
            }
          }
        } else {

          // 直接在最外层
          fromKeyValue = applicationData[trimedKey];
        }
        if (fromKeyValue) {
          fromValues.push(fromKeyValue);
        }
      });
      return fromValues;
    },

    // 字段是否需要监听其他数据的变动
    isFieldNeedWatch() {
      // dataSet为8（兼容配置为'8'）的字段是自动计算字段，需要在别的字段改变的时候计算出当前字段的值
      const autoComputedFlag = this.field.dataSet === 8 || this.field.dataSet === '8';

      // 字段支持监听
      const isConfigedAndFromKeySupport = this.field.fromKey && this.field.fromFunc && applicationHiddenFieldService[this.field.fromFunc];

      return autoComputedFlag && isConfigedAndFromKeySupport;
    },

    // 启动自动计算字段的监听
    setAutoComputedFieldWatcher() {

      // 可以选择至今的日期选择框需要监听当前fieldModel, 这样在已经选中至今之后，再刷新，才能正确显示
      if (this.field.type === 'DateBox' && this.field.toNow) {
        this.$watch('fieldModel', (newValue) => {
          this.datePickerSelectToNow = newValue === '至今';
        });
      }

      // 需要监听，且现在是可以编辑的状态下
      if (this.isFieldNeedWatch() && !this.fieldDisabled) {

        // 监听申请表数据的变化，设置需要自动计算的字段内容（这个字段每次改变都是整体指针改变）
        this.autoFillWatcherFunction = this.$watch('applicationData', (newValue, oldValue) => {
          if (!_.isEqual(newValue, oldValue)) {

            // 监听字段名可能有多个值
            const fromKeys = this.field.fromKey.split(',');
            const fromValues = this.getFromValues(fromKeys, newValue);

            // 如果需要多个值才能计算的，需要都有了才执行计算
            if (fromKeys.length === fromValues.length) {
              this.changeFieldValue(this.field.name, applicationHiddenFieldService[this.field.fromFunc](...fromValues));
            }
          }
        });
      }
    },
  },
  created() {
    this.setRegExp();
    this.setAutoComputedFieldWatcher();
  },
  destroyed() {

    // 清除监听器
    if (this.autoFillWatcherFunction) {
      this.autoFillWatcherFunction();
    }
  },
};
</script>

<style lang="less">
@import "../../../assets/less/variable";
div.application-field {
  .input-field {
    &.upper-case {
      input {
        text-transform: uppercase;
      }
    }
  }
  .el-radio + .el-radio {
    margin-left: 30px;
  }
  div.field-ctrl {
    overflow-wrap: break-word;
    &.invalid {
      input {
        border-color: @text-red;
      }
      .el-radio__label {
        color: @text-red;
      }
    }
  }
}

.application-date-picker {
  width: 289px !important; // 跟高度一样
}
</style>


<style lang="less" scoped>
@import "../../../assets/less/variable";

div.application-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  &.hidden {
    display: none;
  }
  &.level-2 {
    padding-left: 20px;
  }
  &.level-4{
    padding-left: 40px;
  }
  &:last-child {
    margin-bottom: 0;
  }
  &.radio-field {
    border-top: 1px solid @border;
    padding-top: 20px;
    position: relative;
    &.level-2 {
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: -1px;
        width: 30px;
        height: 3px;
        background-color: white;
      }
    }
    &.level-4 {
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: -1px;
        width: 50px;
        height: 3px;
        background-color: white;
      }
    }
  }
  div.field-content {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: @text-dark;
    div.field-label {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      line-height: 1.45;
      padding-right: 10px;
      font-weight: 600;
      &.invalid {
        color: @text-red;
      }
      &.level-2, &.level-4 {
        font-weight: normal;
      }
    }
    div.field-ctrl {
      &.invalid {
        border-color: @text-red;
      }
      .input-field,
      .radio-field,
      .select-field,
      .date-picker-box,
      .pcd-field {
        width: 100%;
      }
      .date-picker-box {
        display: flex;
        align-items: center;
        .date-field {
          width: 100%;
          &.space-for-to-now {
            width: auto;
            flex: 1;
          }
        }
        .to-now-check-box {
          width: 60px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  div.field-ctrl-error-msg {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    align-self: flex-end;
    line-height: 1;
    margin-top: 10px;
    span {
      color: @text-red;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-field.vue